import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  RadioGroupProps,
  RadioProps,
} from "@mui/material";

function RadioInput<T>({
  label,
  value,
  sx,
  ...rest
}: RadioProps & { label?: string; value?: T }) {
  return (
    <FormControlLabel
      label={label}
      value={value}
      control={
        <Radio
          sx={{
            color: "var(--color-dark)",
            "&.Mui-checked": {
              color: "var(--color-fasmr-blue)",
            },
            ...sx,
          }}
          {...rest}
        />
      }
    />
  );
}
export default RadioInput;

export function RadioInputGroup({
  label,
  ...rest
}: RadioGroupProps & { label?: string }) {
  return label ? (
    <FormControl
      sx={{
        p: "var(--surface-padding)",
        border: "1px solid #ccc",
        borderRadius: "4px",
        "&:hover": { borderColor: "#1976d2" },
        "&.Mui-focused": { borderColor: "#1976d2" },
      }}
    >
      <FormLabel>{label}</FormLabel>
      <RadioGroup {...rest} />
    </FormControl>
  ) : (
    <RadioGroup {...rest} />
  );
}
